import Translate from '../i18n/Translate'
import ListContainer from '../containers/MiceContact/ListContainer'
//Components
import OperatorsGallery from '../components/OperatorsGallery'
import MiceContactForm from '../components/MiceContact/MiceContactForm'
//Intersection
import { useInView } from 'react-intersection-observer'
//Hooks
import useScrollTop from '../hooks/useScrollTop'
import useSetI18nProviderInformation from '../hooks/useSetI18nProviderInformation'

const MiceContact = () => {
    useScrollTop()
    useSetI18nProviderInformation('mice_contact')

    const [miceContactTop, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5,
    })

    return (
        <main className="incoming-mice-contact">
            <section className="incoming-mice-contact__top">
                <div className={`content animate slide-title ${inView ? 'in-view' : ''}`} ref={miceContactTop}>
                    <h1 className="title top-title">
                        <Translate langkey="mice.title" />
                    </h1>
                    <p className="copy top-subtitle">
                        <Translate langkey="mice.subtitle" />
                    </p>
                </div>
            </section>

            <ListContainer />

            <MiceContactForm />

            <OperatorsGallery />
        </main>
    )
}

export default MiceContact
